(function () {
  const DRAWER_ROOT_SELECTOR =
    '[data-cart-drawer], #CartDrawer, cart-drawer, [data-drawer="cart"]';

  function forceDrawerOpen() {
    const drawer = document.querySelector(DRAWER_ROOT_SELECTOR);
    if (!drawer) return;

    drawer.classList.add('is-open', 'open', 'active');

    try {
      drawer.setAttribute('aria-hidden', 'false');
    } catch {}

    if (drawer.tagName && drawer.tagName.toLowerCase() === 'cart-drawer') {
      try {
        drawer.setAttribute('open', '');
        drawer.open = true;
      } catch {}
    }
  }

  const $$ = (sel, ctx = document) =>
    Array.from((ctx || document).querySelectorAll(sel));

  function parseHandleAndVariantFromLink(aEl) {
    if (!aEl) return {};

    try {
      const u = new URL(aEl.getAttribute('href'), window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const pIdx = parts.indexOf('products');

      return {
        handle: pIdx > -1 ? parts[pIdx + 1] : '',
        variantId: u.searchParams.get('variant') || ''
      };
    } catch {
      return {};
    }
  }

  async function getJSON(url) {
    const r = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!r.ok) throw new Error(r.status);

    return r.json();
  }

  async function postJSON(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    if (!r.ok) {
      throw new Error(
        await r.text().catch(() => String(r.status))
      );
    }

    return r.json();
  }

  function getSellingPlans(productJson) {
    const groups = productJson?.selling_plan_groups || [];

    return groups.flatMap(group =>
      (group.selling_plans || []).map(plan => ({
        id: plan.id,
        name: plan.name || '',
        groupName: group.name || ''
      }))
    );
  }

  function cleanPlanName(name) {
    return String(name || '')
      .replace(/subscription with.*discount/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function makeInitialCTA(plan) {
    const wrap = document.createElement('div');
    wrap.className = 'rc-upsell-wrap';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rc-upsell-link';
    btn.textContent = 'Subscribe & Save 20%';
    btn.dataset.sellingPlanId = String(plan.id);

    wrap.appendChild(btn);

    return wrap;
  }

  function makeSubscribedPicker(plans, selectedPlanId) {
    const wrap = document.createElement('div');
    wrap.className = 'rc-upsell-wrap rc-upsell-subscribed';

    const label = document.createElement('div');
    label.className = 'rc-upsell-label';
    label.textContent = 'Subscribed! Pick Your Frequency';

    const selectWrap = document.createElement('div');
    selectWrap.className = 'rc-upsell-select-wrap';

    const select = document.createElement('select');
    select.className = 'rc-upsell-select';

    const oneTime = document.createElement('option');
    oneTime.value = '';
    oneTime.textContent = 'One-Time Only';

    select.appendChild(oneTime);

    plans.forEach(plan => {
      const option = document.createElement('option');

      option.value = String(plan.id);
      option.textContent =
        cleanPlanName(plan.name) ||
        plan.name ||
        `Subscription ${plan.id}`;

      select.appendChild(option);
    });

    select.value = String(
      selectedPlanId || plans[0]?.id || ''
    );

    selectWrap.appendChild(select);
    wrap.appendChild(label);
    wrap.appendChild(selectWrap);

    return wrap;
  }

  function setLoading(el, on) {
    if (!el) return;

    el.disabled = !!on;
    el.classList.toggle('is-loading', !!on);

    if (el.tagName !== 'SELECT') {
      if (on) {
        el.dataset.originalText = el.textContent;
        el.textContent = 'Updating…';
      } else if (el.dataset.originalText) {
        el.textContent = el.dataset.originalText;
        delete el.dataset.originalText;
      }
    }
  }

  async function changeLineToSubscription(
    lineIndex,
    qty,
    planId
  ) {
    return postJSON('/cart/change.js', {
      line: Number(lineIndex),
      quantity: Number(qty),
      selling_plan: Number(planId)
    });
  }

  async function changeLineToOneTime(lineIndex, qty) {
    return postJSON('/cart/change.js', {
      line: Number(lineIndex),
      quantity: Number(qty),
      selling_plan: null
    });
  }

  async function removeLine(lineIndex) {
    return postJSON('/cart/change.js', {
      line: Number(lineIndex),
      quantity: 0
    });
  }

  async function addSubscription(
    variantId,
    qty,
    planId
  ) {
    return postJSON('/cart/add.js', {
      items: [
        {
          id: Number(variantId),
          quantity: Number(qty),
          selling_plan: Number(planId)
        }
      ]
    });
  }

  async function addOneTime(variantId, qty) {
    return postJSON('/cart/add.js', {
      items: [
        {
          id: Number(variantId),
          quantity: Number(qty)
        }
      ]
    });
  }

  function attachSubscribeClick(
    btn,
    cta,
    plans,
    lineIndex,
    qty,
    variantId,
    target
  ) {
    btn.addEventListener('click', async e => {
      e.preventDefault();

      const selectedPlan = plans[0];

      if (!selectedPlan) return;

      forceDrawerOpen();
      setLoading(btn, true);

      try {
        try {
          await changeLineToSubscription(
            lineIndex,
            qty,
            selectedPlan.id
          );
        } catch {
          await removeLine(lineIndex);

          await addSubscription(
            variantId,
            qty,
            selectedPlan.id
          );
        }

        cta.remove();

        const picker = makeSubscribedPicker(
          plans,
          selectedPlan.id
        );

        target.appendChild(picker);

        const select = picker.querySelector(
          '.rc-upsell-select'
        );

        attachPickerChange(
          select,
          plans,
          lineIndex,
          qty,
          variantId,
          target
        );

        document.dispatchEvent(
          new CustomEvent('cart:updated')
        );

        document.dispatchEvent(
          new CustomEvent('cart:line:changed', {
            detail: {
              line: lineIndex
            }
          })
        );

        forceDrawerOpen();
      } catch (err) {
        console.error(
          '[RC Upsell] switch failed',
          err
        );

        forceDrawerOpen();
      } finally {
        setLoading(btn, false);
      }
    });
  }

  function attachPickerChange(
    select,
    plans,
    lineIndex,
    qty,
    variantId,
    target
  ) {
    select.addEventListener('change', async () => {
      const selectedPlanId = select.value;

      forceDrawerOpen();
      setLoading(select, true);

      try {
        if (selectedPlanId === '') {
          try {
            await changeLineToOneTime(
              lineIndex,
              qty
            );
          } catch {
            await removeLine(lineIndex);
            await addOneTime(variantId, qty);
          }

          target
            .querySelectorAll(
              '.rc-upsell-wrap, .rc-upsell-switched'
            )
            .forEach(el => el.remove());

          const cta = makeInitialCTA(plans[0]);

          target.appendChild(cta);

          const btn = cta.querySelector(
            '.rc-upsell-link'
          );

          attachSubscribeClick(
            btn,
            cta,
            plans,
            lineIndex,
            qty,
            variantId,
            target
          );
        } else {
          const selectedPlan = plans.find(
            plan =>
              String(plan.id) === selectedPlanId
          );

          if (!selectedPlan) return;

          await changeLineToSubscription(
            lineIndex,
            qty,
            selectedPlan.id
          );
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated')
        );

        document.dispatchEvent(
          new CustomEvent('cart:line:changed', {
            detail: {
              line: lineIndex
            }
          })
        );

        forceDrawerOpen();
      } catch (err) {
        console.error(
          '[RC Upsell] frequency change failed',
          err
        );
      } finally {
        setLoading(select, false);
      }
    });
  }

  async function injectForRow(row) {
    if (row.dataset.rcDone === '1') return;

    const link = row.querySelector(
      'a.link.product-title, a.product-title, a[href*="/products/"]'
    );

    const qtyInput = row.querySelector(
      '.quantity__input[data-index]'
    );

    const cartItem = row.closest(
      'li[data-handle][data-variant-id]'
    );

    if (!qtyInput) {
      row.dataset.rcDone = '1';
      return;
    }

    const linkData = link
      ? parseHandleAndVariantFromLink(link)
      : {};

    const handle =
      linkData.handle ||
      cartItem?.dataset.handle ||
      row.dataset.handle ||
      '';

    const variantId =
      linkData.variantId ||
      cartItem?.dataset.variantId ||
      row.dataset.variantId ||
      '';

    const lineIndex = Number(
      qtyInput.getAttribute('data-index') ||
      cartItem
        ?.querySelector(
          'cart-remove-button[data-index]'
        )
        ?.getAttribute('data-index') ||
      '0'
    );

    const qty = Number(
      qtyInput.value ||
      cartItem?.dataset.quantity ||
      '1'
    );

    if (!handle || !variantId || !lineIndex) {
      row.dataset.rcDone = '1';
      return;
    }

    let plans = [];

    try {
      const productJson = await getJSON(
        `/products/${encodeURIComponent(handle)}.js`
      );

      plans = getSellingPlans(productJson);
    } catch (err) {
      console.warn(
        `[RC Upsell] Could not load plans for ${handle}`,
        err
      );
    }

    if (!plans.length) {
      row.dataset.rcDone = '1';
      return;
    }

    /*
     * Always insert at the bottom of product-description.
     * This keeps the upsell below the title, quantity and price.
     */
    const target =
      row.querySelector('.product-description') ||
      row.querySelector('.product-content') ||
      row;

    target
      .querySelectorAll(
        '.rc-upsell-wrap, .rc-upsell-switched'
      )
      .forEach(el => el.remove());

    const alreadySubscribed = row.querySelector(
      '[data-selling-plan], .cart-item__selling-plan'
    );

    if (alreadySubscribed) {
      const picker = makeSubscribedPicker(
        plans,
        plans[0].id
      );

      target.appendChild(picker);

      const select = picker.querySelector(
        '.rc-upsell-select'
      );

      attachPickerChange(
        select,
        plans,
        lineIndex,
        qty,
        variantId,
        target
      );

      row.dataset.rcDone = '1';
      return;
    }

    const cta = makeInitialCTA(plans[0]);

    target.appendChild(cta);

    row.dataset.rcDone = '1';

    const btn = cta.querySelector(
      '.rc-upsell-link'
    );

    attachSubscribeClick(
      btn,
      cta,
      plans,
      lineIndex,
      qty,
      variantId,
      target
    );
  }

  function scanAndInject(root = document) {
    $$('.product-container', root).forEach(
      injectForRow
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scanAndInject()
    );
  } else {
    scanAndInject();
  }

  const drawerRoot =
    document.querySelector(
      DRAWER_ROOT_SELECTOR
    ) || document.body;

  const mo = new MutationObserver(() => {
    scanAndInject(drawerRoot);
  });

  mo.observe(drawerRoot, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'cart:open',
    () => {
      forceDrawerOpen();
      scanAndInject(drawerRoot);
    }
  );

  document.addEventListener(
    'cart:updated',
    () => {
      forceDrawerOpen();
      scanAndInject(drawerRoot);
    }
  );

  const css = `
.rc-upsell-wrap {
      margin-top: 14px;
      max-width: 240px;
      color: #64690c;
      font-size: 13px;
      line-height: 1.35;
    }

    .rc-upsell-link {
      background: transparent;
      border: 0;
      padding: 0;
      font: inherit;
      font-weight: 700;
      color: #64690c;
      text-decoration: underline;
      cursor: pointer;
    }

    .rc-upsell-link.is-loading,
    .rc-upsell-select.is-loading {
      opacity: .6;
      pointer-events: none;
    }

    .rc-upsell-label {
      font-size: 13px;
      font-weight: 700;
      color: #64690c;
      margin-bottom: 4px;
    }

    .rc-upsell-select-wrap {
      display: inline-block;
      position: relative;
      border: 1px solid #bdbdbd;
      padding: 5px;
     
    }

    .rc-upsell-select {
      appearance: none;
      -webkit-appearance: none;
      border: 0;
      background: transparent;
      padding: 0 15px 0 5px;
      color: #64690c;
      font: inherit;
      font-size: 13px;
      cursor: pointer;
      margin-left:0px;
      
    }

    .rc-upsell-select-wrap::after {
      content: "⌄";
      position: absolute;
      right: 5px;
      top: 40%;
      transform: translateY(-55%);
      pointer-events: none;
      color: #64690c;
      font-size: 13px;
    }

    .rc-upsell-select:focus {
      outline: none;
    }

    .rc-upsell-select option {
      color: #333;
      background: #f4f4f4;
    }
  `;

  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
})();
